module.exports = __webpack_public_path__ + "img/circle.82e7574b.svg";